/**
 * @file The Metrics explorer's "Select Metric" and "Group" options in design
 * order (groups: team, then territory or market segment, then salesperson and
 * manufacturer, as both design files list them), each available with the
 * series query or group it asks for, or unavailable with the tooltip "Not
 * available yet", so the explorer disables it rather than hiding it.
 * Consumers: the Metrics tab and `metricsSeriesFigure` (a metric's label and
 * unit). A label holding `<team>` names the team noun, which the explorer
 * fills from the scope labels, as report titles do.
 */
import type {
  AnalyticsSeriesGroupOption,
  AnalyticsSeriesMetric,
  AnalyticsSeriesUnavailable,
} from './analyticsMetricsTab.types';

const UNAVAILABLE: AnalyticsSeriesUnavailable = {
  status: 'unavailable',
  tooltip: 'Not available yet',
};

export const ANALYTICS_SERIES: {
  metrics: readonly AnalyticsSeriesMetric[];
  groups: readonly AnalyticsSeriesGroupOption[];
} = {
  metrics: [
    {
      status: 'available',
      label: 'Sales credit — booked',
      query: 'bookedSeries',
      unit: 'money',
    },
    { label: 'Sales credit — quoted', ...UNAVAILABLE },
    {
      status: 'available',
      label: 'Orders written',
      query: 'ordersWrittenSeries',
      unit: 'count',
    },
    { label: 'Line items shipped', ...UNAVAILABLE },
    { label: 'Invoice amount outstanding', ...UNAVAILABLE },
    {
      status: 'available',
      label: 'Quotes issued',
      query: 'quotesIssuedSeries',
      unit: 'count',
    },
  ],
  groups: [
    { status: 'available', label: 'Across all entities', group: 'all' },
    { status: 'available', label: 'By <team>', group: 'team' },
    { label: 'By territory', ...UNAVAILABLE },
    { label: 'By market segment', ...UNAVAILABLE },
    { status: 'available', label: 'By salesperson', group: 'salesperson' },
    { label: 'By manufacturer', ...UNAVAILABLE },
  ],
};
